"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _time = require("../../../helpers/time/time");

var _ratio = require("../../../services/ratio/ratio.service");

var _ratio2 = _interopRequireDefault(require("../../shapes/ratio.shape"));

const MIN_MARGIN_FROM_VIEWPORT = 7;

class VideoSeekPreview extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "bindEvents", () => {
      this.props.timeBar.addEventListener('mousemove', this.updateTooltip);
    });
    (0, _defineProperty2.default)(this, "updateTooltip", ev => {
      if (Number.isFinite(this.props.time) && ev instanceof MouseEvent) {
        return;
      }

      const pageXOffset = window.pageXOffset;
      const timeBarRect = this.props.timeBar.getBoundingClientRect();
      const tooltipRect = this.tooltip.getBoundingClientRect();
      const tooltipHalfWidth = tooltipRect.width / 2;
      const right = (timeBarRect.width || timeBarRect.right) + pageXOffset;
      let left = ev.pageX - timeBarRect.left;
      this.updateTimeBarMark(left, timeBarRect); // bound to window edges

      const tooltipLeftEdge = left - tooltipHalfWidth;
      const leftEdgeOnPage = timeBarRect.left + tooltipLeftEdge;
      const rightEdgeOnPage = leftEdgeOnPage + tooltipRect.width;
      const leftOverflow = leftEdgeOnPage - MIN_MARGIN_FROM_VIEWPORT;
      const rightOverflow = window.innerWidth - MIN_MARGIN_FROM_VIEWPORT - rightEdgeOnPage;

      if (leftOverflow < 0) {
        left -= leftOverflow;
      }

      if (rightOverflow < 0) {
        left += rightOverflow;
      } // keep the seek-preview inside of the player


      if (left + tooltipHalfWidth > right) {
        left -= left + tooltipHalfWidth - right;
      } else if (left < tooltipHalfWidth) {
        left = tooltipHalfWidth;
      } // end bounding


      const time = this.getTimeFromMouseEvent(ev); // prevent crashes while video is being updated (src changed etc.)

      if (Number.isNaN(time)) {
        return;
      }

      (0, _lodash.throttle)(seekTo => {
        this.setState({
          videoTime: seekTo,
          left: "".concat(left, "px")
        });
      }, 100)(time);
    });
    this.state = {
      videoTime: 0,
      left: 0
    };
  }

  componentDidMount() {
    this.videoEl.addEventListener('canplay', this.bindEvents);
    this.videoEl.addEventListener('contextmenu', this.blockContextMenu); // for iOS, see https://stackoverflow.com/a/18283198/324094

    if (!global.__TEST__) {
      this.videoEl.load();
      this.videoEl.pause();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (Number.isFinite(nextProps.time) && nextProps.time !== this.props.time) {
      const pixel = this.getPositionFromTime(nextProps.time);
      const timeBarRect = this.props.timeBar.getBoundingClientRect();
      const pageX = pixel + timeBarRect.left;
      this.updateTooltip({
        pageX
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {
      videoTime,
      left
    } = this.state;
    const {
      time
    } = this.props;
    return videoTime !== nextState.videoTime || time !== nextProps.time || left !== nextState.left;
  }

  componentDidUpdate() {
    const {
      videoTime
    } = this.state;

    if (this.videoEl.fastSeek) {
      this.videoEl.fastSeek(videoTime);
    } else {
      this.videoEl.currentTime = videoTime;
    }
  }

  componentWillUnmount() {
    this.props.timeBar.removeEventListener('mousemove', this.updateTooltip);
    this.videoEl.removeEventListener('canPlay', this.bindEvents);
    this.videoEl.removeEventListener('contextmenu', this.blockContextMenu);
  }

  blockContextMenu(ev) {
    ev.preventDefault();
  }

  getTimeFromMouseEvent(ev) {
    const width = parseFloat(this.props.timeBar.getBoundingClientRect().width);
    const relX = parseFloat(ev.pageX - this.props.timeBar.getBoundingClientRect().left);
    return this.getTimeFromPosition(relX / width);
  }

  getPositionFromTime(time) {
    const width = parseFloat(this.props.timeBar.getBoundingClientRect().width);
    const {
      duration
    } = this.videoEl;
    const portionFromTotal = time / duration;
    const position = Math.round(width * portionFromTotal);
    return position;
  } // position in percentage


  getTimeFromPosition(position) {
    const {
      videoEl
    } = this;
    return Math.max(0, Math.min(videoEl.duration, videoEl.duration * position));
  } // calculate a relative percentage from the given hovered point, to be used from css to stretch the 'hover bar' to that point


  updateTimeBarMark(x, timeBarRect) {
    const percentage = x / timeBarRect.width * 100;
    const normalized = Math.min(Math.max(0, percentage), 100);
    this.props.timeBar.style.setProperty('--hover-bar-width', "".concat(normalized, "%"));
  }

  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "video-seek-preview",
      ref: el => {
        this.tooltip = el;
      },
      style: {
        left: this.state.left,
        visibility: this.props.show ? 'visible' : 'hidden'
      }
    }, /*#__PURE__*/_react.default.createElement("video", {
      ref: el => {
        this.videoEl = el;
      },
      height: "100%",
      preload: "auto",
      src: this.props.videoUrl,
      muted: true,
      playsInline: true
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-seek-preview__time"
    }, (0, _time.durationFormat)(this.state.videoTime)));
  }

}

exports.default = VideoSeekPreview;
(0, _defineProperty2.default)(VideoSeekPreview, "propTypes", {
  timeBar: _propTypes.default.instanceOf(global.Element).isRequired,
  videoUrl: _propTypes.default.string.isRequired,

  /* eslint-disable react/no-unused-prop-types */
  ratio: _ratio2.default,
  resolution: _propTypes.default.number,

  /* eslint-enable react/no-unused-prop-types */
  show: _propTypes.default.bool.isRequired,
  time: _propTypes.default.number
});
(0, _defineProperty2.default)(VideoSeekPreview, "defaultProps", {
  ratio: _ratio.RATIOS_BY_NAME.wide.key,
  resolution: _ratio.RATIOS_BY_NAME.wide.height,
  time: undefined
});